module.exports = __webpack_public_path__ + "img/跳转链接.e690995e.svg";